import { Choice, Num, Text, Toggle } from "./fields";

export const BehaviorTab = ({ d, set }) => (
  <div className="space-y-4" data-testid="tab-behavior">
    <Toggle k="enabled" d={d} set={set} label="Chatbot ON / OFF" on="Shown on every page of the website" off="Hidden from visitors" />
    <div className="grid sm:grid-cols-2 gap-3">
      <Choice k="open_behavior" d={d} set={set} label="Opening behaviour" options={[["manual", "Only when the visitor taps it"], ["auto_first", "Open automatically on a visitor's first visit"], ["auto_always", "Open automatically every visit"]]} />
      <Num k="open_delay_s" d={d} set={set} label="Auto-open delay (seconds)" min={0} max={300} hint="Used only for the automatic options." />
    </div>
    <div className="rounded-xl border border-border bg-white/60 p-3 space-y-3">
      <Toggle k="teaser_enabled" d={d} set={set} label="Little “Need help?” bubble next to the launcher" on="Shown once per visit, a few seconds after the page loads" off="Never shown" />
      <div className="grid sm:grid-cols-3 gap-3">
        <Text k="teaser_title" d={d} set={set} label="Bubble title" max={60} />
        <Text k="teaser_text" d={d} set={set} label="Bubble text" max={120} />
        <Num k="teaser_delay_s" d={d} set={set} label="Show after (seconds)" min={0} max={120} step={0.5} />
      </div>
    </div>
    <p className="text-[11px] text-muted-foreground">The close button, the “Not you?” unlink and the privacy rules are always available and cannot be switched off.</p>
  </div>
);
